import React from 'react';
import { translate } from 'react-i18next';
import {Button, Label, Icon, Header} from 'semantic-ui-react'
import _ from 'underscore';
import moment from 'moment';
import LoadInline from 'modules/loading/LoadInline.js';

import SurveyPageModalContainer from './SurveyPageModalContainer.js';
import Utils from 'utils/Utils.js';
import {colors, fontSizes, fonts, spacings, shadow, layout} from 'style';

const daysToTimeValue = 86400000;

var style = {
    container: {
        maxWidth: layout.screenWidth,
        boxShadow: layout.screenShadow,
        minHeight: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundColor: 'white',
        ...fonts.body,
        lineHeight: '1.5',
        color: colors.themeDarkerGrey,
    },
    content: {
        padding: spacings.base,
    },
    yourHealthInfo: {
        textAlign: 'center',
    },
    healthGradeLabel: {
        color: colors.themeBlue,
    },
    healthGrade: {
        color: colors.themeBlue,
        fontSize: fontSizes.h2,
    },
    form: {
        maxWidth: '400px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    rightChevron: {
        float: 'right',
    },
    answer:{
        paddingLeft: spacings.base,
    },
    inlineItem: {
        cursor: 'pointer',
    }
}

const SurveyPageDateInline = ({t, surveyPage, onClick}) => {
    var epochDays = Utils.deref(surveyPage, 'challenge.userChallenge.value', null);
    var dateString = '';
    if(epochDays!==null && epochDays!==undefined) {
        var time = epochDays*daysToTimeValue;
        var momentDate = moment.utc(time).startOf('day');
        dateString = momentDate.format('MMM D, YYYY');
    }
    return (
        <div onClick={onClick} style={style.inlineItem}>
            <div>{surveyPage.title}</div>
            <span style={style.answer}>{dateString ? dateString : t('N/A')}</span> <i style={style.rightChevron} className='icon-chevron-right'></i>
            <hr />
        </div>);
};
const SurveyPageMultiInline = ({t, surveyPage, onClick}) => {
    var userChallengeAnswers = Utils.deref(surveyPage, 'challenge.userChallenge.userChallengeAnswers', []);
    var challengeAnswers = Utils.deref(surveyPage, 'challenge.challengeAnswers', [])
                                .reduce((m,ca)=>{m[ca.id] = ca; return m}, {});
    var answers = userChallengeAnswers.map(uca=>challengeAnswers[uca.challengeAnswerId].label);
    return (
        <div onClick={onClick} style={style.inlineItem}>
            <div>{surveyPage.title}</div> <i style={style.rightChevron} className='icon-chevron-right'></i>
            {answers.length==0 &&
                <div style={style.answer}>{t('N/A')}</div>
            }
            {answers.map((a,i)=>(<div style={style.answer} key={i}>{a}</div>))}
            <hr />
        </div>);
};
const SurveyPageNumberInline = ({t, surveyPage, onClick}) => {
    var number = Utils.deref(surveyPage, 'challenge.userChallenge.value', '');
    number = _.isFinite(number) ? number : '';
    return (    
        <div onClick={onClick} style={style.inlineItem}>
            <div>{surveyPage.title}</div>
            {Boolean(number!=='') ? (
                    <span style={style.answer}>{number}</span> 
                ) : (
                    <span style={style.answer}>{t('N/A')}</span> 
                )
            }
            <i style={style.rightChevron} className='icon-chevron-right'></i>
            <hr />
        </div>);
};
const SurveyPageLengthInline = ({t, surveyPage, onClick}) => {
    const cm_to_mm = 10.0;
    var mm = Utils.deref(surveyPage, 'challenge.userChallenge.value', '');
    var cm = _.isFinite(mm) ? mm/cm_to_mm : '';
    return (
        <div onClick={onClick} style={style.inlineItem}>
            <div>{surveyPage.title}</div>
            {Boolean(cm!=='') ? (
                    <span style={style.answer}>{cm} cm</span> 
                ) : (
                    <span style={style.answer}>{t('N/A')}</span> 
                )
            }
            <i style={style.rightChevron} className='icon-chevron-right'></i>
            <hr />
        </div>);
};
const SurveyPageWeightInline = ({t, surveyPage, onClick}) => {
    const kg_to_gram = 1000.0;
    var gram = Utils.deref(surveyPage, 'challenge.userChallenge.value', '');
    var kg = _.isFinite(gram) ? gram/kg_to_gram : '';
    return (
        <div onClick={onClick} style={style.inlineItem}>
            <div>{surveyPage.title}</div>
            {Boolean(kg!=='') ? (
                    <span style={style.answer}>{kg} kg</span> 
                ) : (
                    <span style={style.answer}>{t('N/A')}</span> 
                )
            }
            <i style={style.rightChevron} className='icon-chevron-right'></i>
            <hr />
        </div>);
};

const SurveyPageInline = (props) => {
    switch (props.surveyPage.type) {
        case 2: return <SurveyPageMultiInline  {...props} />;
        case 3: return <SurveyPageLengthInline {...props} />;
        case 4: return <SurveyPageWeightInline {...props} />;
        case 5: return <SurveyPageDateInline   {...props} />;
        case 7: return <SurveyPageNumberInline {...props} />;
        case 9: return <SurveyPageMultiInline  {...props} />;
        case 8: return <SurveyPageLengthInline {...props} />;
        default: return null;
    }
};

const MyHealth = ({t, busy, error, survey, userHealth, selectedSurveyPage, onSelectSurveyPage, onCloseModal, onModalUpdateComplete}) => (
    <div style={style.container}>
        <div style={style.content}>
            {busy && 
                <LoadInline centered vcentered /> 
            }
            {Boolean(userHealth) &&
                <div style={style.yourHealthInfo}>
                    <div style={style.healthGradeLabel}>{t('profile:::Your Health Grade')}</div>
                        <div style={style.healthGrade}>{Number(userHealth.overall).toFixed(1)}</div>

                    {Boolean(userHealth && userHealth.averageAgeSex) &&
                        <div>{t('profile:::The average for your age and sex demograhic is {{value}}', {value:userHealth.averageAgeSex.toFixed(1)})}</div>
                    }
                </div>
            }

            <br />

            {Boolean(survey && survey.surveyPages) &&
                <div style={style.form}>
                    {survey.surveyPages.filter(sp=>Boolean(sp.challenge)).map(surveyPage => (
                        <div key={surveyPage.id}>
                            <SurveyPageInline t={t} surveyPage={surveyPage} onClick={()=>onSelectSurveyPage(surveyPage)} />
                        </div>
                    ))}
                </div>
            }

            <br />

            <div>{t('hra_explanation')}</div>

            {selectedSurveyPage &&
                <SurveyPageModalContainer surveyPage={selectedSurveyPage} onClose={onCloseModal} onCompleted={onModalUpdateComplete} />
            }
        </div>
    </div>
);

export default translate(['surveys', 'profile'])(MyHealth);



// WEBPACK FOOTER //
// ./src/modules/surveys/MyHealth.js